"use client"

import { Text } from "@/elements"
import { PostAJobResponseDataFragment } from "@/gql/graphql"
import type { NovaSession } from "@/types"
import React from "react"
import { JobInviteCreativeCard } from "../JobInviteCreativeCard"

interface Props {
  serverSession: NovaSession
  jobPostingResponseData: PostAJobResponseDataFragment | null
  handleClickInviteCard: (creativeId: string) => void
  selectedCreatives: string[]
}

export const InviteCreativesStep: React.FC<Props> = ({
  serverSession,
  selectedCreatives,
  handleClickInviteCard,
  jobPostingResponseData,
}) => {
  const suggestedCreatives = jobPostingResponseData?.suggestedCreatives?.edges
  const positionName = jobPostingResponseData?.position?.name
  const positionNamePlural = jobPostingResponseData?.position?.pluralizedName

  return (
    <div className="relative">
      <div className="mb-5 mt-[56px]">
        <Text variant="label" className="text-primary-5">
          Nice! Your job was posted!
        </Text>
      </div>
      <div className="mb-8">
        <Text variant="h5" className="max-w-[447px]">
          We found{" "}
          <Text element="span" className="text-primary-3" variant="h5">
            {suggestedCreatives?.length}{" "}
            {suggestedCreatives?.length && suggestedCreatives?.length > 1 ? positionNamePlural : positionName}
          </Text>{" "}
          that would be a great fit for your job. Invite them to apply:
        </Text>
      </div>
      <div className="my-5 grid grid-cols-1 gap-4 lg:grid-cols-2">
        {suggestedCreatives?.map((edge, index) => {
          const node = edge?.node
          const isIndividualCreative = node?.__typename === "IndividualCreative"
          if (!node || !isIndividualCreative) return null

          const isSelected = selectedCreatives.includes(node.id)

          return (
            <JobInviteCreativeCard
              creative={node}
              selected={isSelected}
              trackingEntryPoint="post-a-job-modal"
              serverSession={serverSession}
              key={node.id}
              onClick={() => handleClickInviteCard(node.id)}
              isRecommended={index < 2}
            />
          )
        })}
      </div>
    </div>
  )
}
